import React, { lazy } from 'react';
import PacketBrowser from 'containers/packet/browser/PacketBrowser';
const Home = lazy(() => import('components/Home'));
const PacketHistory = lazy(() => import('containers/packet/packetHistory'));
const RdimsContainer = lazy(() => import('containers/rdims'));
const CIRBContainer = lazy(() => import('containers/cirb/CIRBContainer'));
const IRBApprovals = lazy(() => import('containers/irb/approval'));
const IRBBrowser = lazy(() => import('containers/irb/IRBApprovalBrowser'));
const LPOBrowser = lazy(() => import('containers/irb/LPOApprovalBrowser'));
const SiteRegBrowser = lazy(() => import('containers/siteRegistration/SiteRegistrationBrowser'));
const SiteRegistrationDetails = lazy(() => import('containers/siteRegistration/details/index'));
const ViewEmailTemplate = lazy(() => import('containers/admin/emailtemplatesetup'));

// admin screens
const AdminCirbSitePrefsContainer = lazy(() => import('containers/admin/cirbSitePrefs/AdminCirbSitePrefsContainer'));
const ListSelectionMaintenance = lazy(() => import('containers/admin/listSelection/ListSelectionMaintenance'));
const EmailTemplateContainer = lazy(() => import('containers/emailtemplate/EmailTemplateContainer'));
const MultiNetwork = lazy(() => import('containers/multinetwork/MultiNetwork'));
const QueueMapping = lazy(() => import('containers/queuemapping/index'));
const PacketLocks = lazy(() => import('../containers/admin/packetLocks'));
const RDIMSLocks = lazy(() => import('../containers/admin/rdimsLocks'));
const SubStudy = lazy(() => import('containers/substudy/SubStudy'));

export const regulatoryTopNavRoutes = [
  {
    path: '/packet',
    name: 'Packets',
    shortName: 'Packet Processing',
    isExact: true,
    element: <PacketBrowser />,
    showInMenu: true,
    permission: 'regulatory.menu.packets.processing',
    browserTabTitle: 'Packets',
    subRoutes: [
      {
        path: '/packet/browser',
        name: 'Browser',
        isExact: true,
        showInMenu: true,
        element: <PacketBrowser />,
        permission: 'regulatory.menu.packets.processing',
        browserTabTitle: 'Packets'
      },
      {
        path: '/packet/details',
        name: 'Details',
        isExact: true,
        showInMenu: false,
        element: <Home />,
        permission: 'regulatory.menu.packets.processing',
        browserTabTitle: 'Packet Details'
      },
      {
        path: '/packet/rdims',
        name: 'RDIMS Browser',
        shortName: 'RDIMS Browser',
        isExact: true,
        showInMenu: true,
        element: <RdimsContainer />,
        permission: 'regulatory.menu.packets.rdims',
        browserTabTitle: 'RDIMS Browser'
      },
      {
        path: '/packet/packet-history',
        name: 'Packet history',
        shortName: 'Packet history',
        isExact: true,
        showInMenu: false,
        element: <PacketHistory />,
        permission: 'regulatory.menu.packets.packethistory', // need to give proper permission
        browserTabTitle: 'Packet history'
      }
    ]
  },
  {
    path: '/cap',
    name: 'CAP',
    shortName: 'CIRB Approval Processing',
    isExact: true,
    element: <CIRBContainer />,
    showInMenu: true,
    permission: 'regulatory.menu.cap',
    subRoutes: [],
    browserTabTitle: 'CAP'
  },
  {
    path: '/site-registration',
    name: 'Site Registration',
    shortName: 'Site Registration',
    isExact: true,
    element: <SiteRegBrowser />,
    showInMenu: true,
    permission: 'regulatory.menu.sitereg.browser',
    browserTabTitle: 'Site Registration Browser',
    subRoutes: [
      {
        path: '/site-registration/browser',
        name: 'Browser',
        isExact: true,
        showInMenu: true,
        element: <SiteRegBrowser />,
        permission: 'regulatory.menu.sitereg.browser',
        browserTabTitle: 'Site Registration Browser'
      },
      {
        path: '/site-registration/details',
        name: 'Details',
        isExact: true,
        showInMenu: true,
        isNewTab: true,
        element: <SiteRegistrationDetails />,
        permission: 'regulatory.menu.sitereg.details',
        browserTabTitle: 'Site Registration'
      }
    ]
  },
  {
    path: '/approvals',
    name: 'Approvals',
    shortName: 'Approvals',
    isExact: true,
    element: <IRBBrowser />,
    showInMenu: true,
    permission: 'regulatory.menu.irb.browser',
    browserTabTitle: 'Approvals',
    subRoutes: [
      {
        path: '/approvals/irb/browser',
        name: 'IRB Approval Browser',
        isExact: true,
        showInMenu: true,
        element: <IRBBrowser />,
        permission: 'regulatory.menu.irb.browser',
        browserTabTitle: 'IRB Approval Browser'
      },
      {
        path: '/approvals/lpo/browser',
        name: 'LPO Approval Browser',
        isExact: true,
        showInMenu: true,
        element: <LPOBrowser />,
        permission: 'regulatory.menu.irb.browser',
        browserTabTitle: 'LPO Approval Browser'
      },
      {
        path: '/approvals/details',
        name: 'IRB/LPO Approval Details',
        isExact: true,
        isNewTab: true,
        showInMenu: false,
        element: <IRBApprovals />,
        permission: 'regulatory.menu.irb.approvals',
        browserTabTitle: 'IRB/LPO Approval Details'
      }
    ]
  },
  {
    path: '/admin',
    name: 'Administration',
    shortName: 'Administration',
    isExact: true,
    element: <AdminCirbSitePrefsContainer />,
    showInMenu: true,
    permission: 'regulatory.menu.admin.cirbprefs',
    browserTabTitle: 'CIRB Site Preferences',
    subRoutes: [
      {
        path: '/admin/adminCirbSitePrefs',
        name: 'CIRB Site Preferences',
        isExact: true,
        showInMenu: true,
        element: <AdminCirbSitePrefsContainer />,
        permission: 'regulatory.menu.admin.cirbprefs',
        browserTabTitle: 'CIRB Site Preferences'
      },
      {
        path: '/admin/multi-network',
        name: 'Multi-Network',
        isExact: true,
        showInMenu: true,
        element: <MultiNetwork />,
        permission: 'regulatory.menu.admin.multinetwork',
        browserTabTitle: 'Multi-Network'
      },
      {
        path: '/admin/listSelectionMaintenance',
        name: 'List Selection Maintenance',
        isExact: true,
        showInMenu: true,
        element: <ListSelectionMaintenance />,
        permission: 'regulatory.menu.admin.listselection',
        browserTabTitle: 'List Selection Maintenance'
      },
      {
        path: '/admin/queue-mapping',
        name: 'Queue-Mapping',
        isExact: true,
        showInMenu: true,
        element: <QueueMapping />,
        permission: 'regulatory.menu.admin.queue',
        browserTabTitle: 'Queue-Mapping'
      },
      {
        path: '/admin/packet-locks',
        name: 'Packet Locks',
        isExact: true,
        showInMenu: true,
        element: <PacketLocks />,
        permission: 'regulatory.menu.admin.packets',
        browserTabTitle: 'Packet Browser Locks'
      },
      {
        path: '/admin/rdims-locks',
        name: 'RDIMS Locks',
        isExact: true,
        showInMenu: true,
        element: <RDIMSLocks />,
        permission: 'regulatory.menu.admin.rdims',
        browserTabTitle: 'RDIMS Locks'
      },
      {
        path: '/admin/sub-study',
        name: 'Sub-Study',
        isExact: true,
        showInMenu: true,
        element: <SubStudy />,
        permission: 'regulatory.menu.admin.substudy',
        browserTabTitle: 'Sub-Study'
      },
      {
        path: '/admin/email-template-setup',
        name: 'Email Template Setup',
        isExact: true,
        showInMenu: true,
        element: <EmailTemplateContainer />,
        permission: 'regulatory.menu.admin.emailtemplate',
        browserTabTitle: 'Email Template Setup'
      },
      {
        path: '/admin/manage-email-template-setup',
        name: 'Email Template Setup',
        isExact: true,
        showInMenu: false,
        element: <ViewEmailTemplate />,
        permission: 'regulatory.menu.admin.emailtemplate',
        browserTabTitle: 'Email Template Detail View'
      }
    ]
  }
];
export const indexRoutes = [
  ...regulatoryTopNavRoutes
];

export default indexRoutes;
